import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AdminPageHeader, Form, AdminFormAction } from '@ui';
import {
  HospitalForm,
  DEFAULT_HOSPITAL_VALUES,
  useHospitalFormSchemaOptionalContact,
} from '@lp/features/admin/forms/HospitalForm';
import { PrimaryContactForm } from '@lp/features/admin/forms/PrimaryContactForm';
import { useContext } from 'react';
import { AuthContext } from '@lp/core/auth';
import { AdminPermissions } from '@/permissions';
import { useCreateHospital } from '@/hooks/useCreateHospital';
import { NewHospitalForm } from '@/types/facility.types';

export const HospitalCreate = () => {
  const navigate = useNavigate();
  const { createHospital } = useCreateHospital();
  const { checkPermission } = useContext(AuthContext);
  const { schema, isLoading: isGeoDataLoading } = useHospitalFormSchemaOptionalContact();

  const hasCreatePermissions = checkPermission(AdminPermissions.HospitalCreate);

  const handleBackToList = () => {
    navigate('/admin/hospitals/locations');
  };

  const handleSubmit = async (data: NewHospitalForm) => {
    try {
      const hospital = await createHospital(data);
      if (hospital) {
        toast.success(`Donor Hospital created successfully.`);
        handleBackToList();
      }
    } catch (error) {
      toast.error((error as Error).message);
    }
  };

  if (isGeoDataLoading) return null;

  return (
    <Form<NewHospitalForm> defaultValues={DEFAULT_HOSPITAL_VALUES} schema={schema} onSubmit={handleSubmit}>
      <div className="flex flex-col gap-9">
        <AdminPageHeader title="Create New Donor Hospital" backToListLink="/admin/hospitals/locations">
          <AdminFormAction type="create" handleClick={handleBackToList} hasCreatePermissions={hasCreatePermissions} />
        </AdminPageHeader>
        <HospitalForm isReadOnly={!hasCreatePermissions} />
        <PrimaryContactForm
          isPhoneRequired={false}
          isRequired={false}
          isReadOnly={!hasCreatePermissions}
          isClearableForm
        />
      </div>
    </Form>
  );
};
